import { NotMigratedComponent } from './auth/not-migrated/not-migrated.component';
import { ErrorPageComponent } from './error-page/error-page.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthLayoutComponent } from './auth/layout.component';
import { AuthGuard } from './services/auth.guard.service';
import { LayoutComponent } from './layout/layout.component';
import { EmailVerifiedGuard } from './services/email-verified.guard.service';



const routes: Routes = [
  {
    path: 'auth',
    component: AuthLayoutComponent,
    children: [
      { path: 'signin', loadChildren: () => import('./auth/signin/signin.module').then(m => m.SignInModule) },
      // tslint:disable-next-line:max-line-length
      { path: 'forgot-password', loadChildren: () => import('./auth/forgot-password/forgot-password.module').then(m => m.ForgotPasswordModule) },
      // { path: 'signup', loadChildren: () => import('./auth/signup/signup.module').then(m => m.SignUpModule) },
      // tslint:disable-next-line: max-line-length
      { path: 'complete-signup', loadChildren: () => import('./auth/signup-complete/signup-complete.module').then(m => m.SignupCompleteModule) },
      // { path: 'reset', loadChildren: () => import('./auth/reset/reset.module').then(m => m.ResetModule) },
      { path: 'verify', loadChildren: () => import('./auth/verify/verify.module').then(m => m.VerifyModule) },
      { path: 'not-verified', loadChildren: () => import('./auth/not-verified/not-verified.module').then(m => m.NotVerifiedModule) },
      { path: 'not-migrated', component: NotMigratedComponent }
    ]
  },
  {
    path: '',
    canActivate: [AuthGuard, EmailVerifiedGuard],
    component: LayoutComponent,

    children: [
      { path: 'dashboard', loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule) },
      { path: 'supplies', loadChildren: () => import('./supplies/supplies.module').then(m => m.SuppliesModule) },
      { path: 'supplies/orders', loadChildren: () => import('./orders/orders.module').then(m => m.OrdersModule) },
      { path: 'supplies/suppliers', loadChildren: () => import('./suppliers/suppliers.module').then(m => m.SuppliersModule) },
      { path: 'usages', loadChildren: () => import('./usages/usages.module').then(m => m.UsagesModule) },
      { path: 'outputs', loadChildren: () => import('./outputs/outputs.module').then(m => m.OutputsModule) },
      { path: 'notifications', loadChildren: () => import('./notifications/notifications.module').then(m => m.NotificationsModule) },
      { path: 'settings', loadChildren: () => import('./settings/settings.module').then(m => m.SettingsModule) },
      { path: 'admin', loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule) },
      { path: '**', component: ErrorPageComponent, pathMatch: 'full' }
    ]
  },


];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
